/* Comforts Kids: Lights-off engine. Vanilla custom element, no library, nothing persisted. */
if (!customElements.get('ck-lights')) {
  (function () {
    var root = document.documentElement;
    // The mode the last tap asked for while its frame is still pending. Two taps in one frame must
    // read the first tap's intent, not the unchanged data-mode, or the second tap is lost.
    var pendingNight = null;

    function isNight() {
      return root.dataset.mode === 'night';
    }

    function currentVariantId(el) {
      var scope = (el.closest && el.closest('product-info')) || document;
      var input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      return input ? String(input.value) : '';
    }

    function findTemplate(container, variantId) {
      if (!variantId) return null;
      var list = container.querySelectorAll('template[data-ck-glow]');
      for (var i = 0; i < list.length; i++) {
        if (list[i].dataset.variantId === variantId) return list[i];
      }
      return null;
    }

    // Marks the image and its holder is-loaded once the glow photo is there; onError runs if it fails,
    // so a slow or broken glow photo never leaves a blank box over the day photo.
    function watchImage(scope, onError) {
      var img = scope.querySelector('img');
      if (!img) return;
      function loaded() {
        img.classList.add('is-loaded');
        scope.classList.add('is-loaded');
      }
      function failed() {
        img.classList.remove('is-loaded');
        scope.classList.remove('is-loaded');
        if (onError) onError();
      }
      if (img.complete && (img.currentSrc || img.getAttribute('src'))) {
        if (img.naturalWidth > 0) loaded();
        else failed();
        return;
      }
      img.addEventListener('load', loaded, { once: true });
      img.addEventListener('error', failed, { once: true });
    }

    function fillGroup(group) {
      var slot = group.querySelector('[data-ck-glow-slot]');
      if (!slot) return;
      var id = group.dataset.ckVariant || currentVariantId(group);
      var tpl = findTemplate(group, id);
      if (!tpl) {
        slot.replaceChildren();
        delete slot.dataset.variantId;
        group.removeAttribute('data-ck-has-glow');
        return;
      }
      if (slot.dataset.variantId !== id || !slot.firstElementChild) {
        slot.replaceChildren(tpl.content.cloneNode(true));
        slot.dataset.variantId = id;
        watchImage(slot, function () {
          if (slot.dataset.variantId !== id) return; // a newer design already took the slot
          // Broken glow photo: back to the day photo with the "Glow photo coming soon" chip (D-07).
          // The next Lights-off or design change tries again.
          slot.replaceChildren();
          delete slot.dataset.variantId;
          group.removeAttribute('data-ck-has-glow');
        });
      }
      group.setAttribute('data-ck-has-glow', '');
    }

    function fillSet(set) {
      var info = set.closest('product-info');
      var gallery = set.closest('media-gallery') || (info || document).querySelector('media-gallery');
      if (!gallery) return;
      var old = gallery.querySelectorAll('.ck-media-glow');
      for (var i = 0; i < old.length; i++) old.item(i).remove();
      var tpl = findTemplate(set, currentVariantId(set));
      if (!tpl) return;
      var li = gallery.querySelector('li.is-active') || gallery.querySelector('li[data-media-id]');
      var host = li && li.querySelector('.product-media-container');
      if (!host) return;
      var overlay = document.createElement('div');
      overlay.className = 'ck-media-glow';
      overlay.setAttribute('data-ck-glow-slot', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.appendChild(tpl.content.cloneNode(true));
      host.appendChild(overlay);
      watchImage(overlay, function () {
        overlay.remove(); // broken glow photo: keep showing the day photo
      });
    }

    var CkGlow = {
      fillAll: function () {
        var groups = document.querySelectorAll('[data-ck-photo]');
        for (var i = 0; i < groups.length; i++) fillGroup(groups[i]);
        var sets = document.querySelectorAll('[data-ck-glow-set]');
        for (var j = 0; j < sets.length; j++) fillSet(sets[j]);
      },
    };
    window.CkGlow = CkGlow;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (!isNight()) return;
        requestAnimationFrame(function () { CkGlow.fillAll(); });
      });
    }

    class CkLights extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button.ck-lights');
        if (!this.button || this.ckReady) return;
        this.ckReady = true;
        this.button.hidden = false;
        this.button.setAttribute('aria-pressed', isNight() ? 'true' : 'false');
        this.button.addEventListener('click', () => CkLights.toggle(this));
      }

      static toggle(source) {
        var night = !(pendingNight !== null ? pendingNight : isNight());
        pendingNight = night;
        if (night) CkGlow.fillAll();
        root.classList.add('ck-switching');
        requestAnimationFrame(function () {
          if (pendingNight === night) pendingNight = null;
          if (night) root.dataset.mode = 'night';
          else delete root.dataset.mode;
          var buttons = document.querySelectorAll('ck-lights button.ck-lights');
          for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', night ? 'true' : 'false');
          var meta = document.querySelector('meta[name="theme-color"]');
          if (meta) meta.setAttribute('content', night ? '#141A3A' : '#E4D9FF');
          var live = source && source.querySelector('[data-ck-live]');
          if (live) {
            live.textContent = '';
            requestAnimationFrame(function () {
              live.textContent = night ? 'Lights off. The blankets are glowing.' : 'Lights on.';
            });
          }
          setTimeout(function () { root.classList.remove('ck-switching'); }, 700);
        });
      }
    }

    customElements.define('ck-lights', CkLights);
  })();
}
